export default "__VITE_ASSET__DxgDLu1p__"